import React from 'react'
import { InputContainer } from '../../../../../../common/components/form/form.module'
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container'

export default function ReconciliationsBasicInfoComponent({
  handleInnerFormChange,
  selectedReconciliation,
  onClose,
  handleFormSubmit
}: any) {

  return (
    <>
      <div className="flex justify-center items-center w-[600px]">
        <div className="w-full max-w-lg p-2 bg-white shadow-md rounded-md">
          <h1 className="text-xl font-bold mb-4 text-center">{selectedReconciliation?.Id ? "Edit Reconciliation" : "Add New Reconciliation"}</h1>
          <div className="flex flex-col gap-4">
          <InputContainer
                    label="OrderId"
                    name="OrderId"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedReconciliation.OrderId',
                      })
                    }}
                    type="text"
                    value={selectedReconciliation.OrderId}
                  />

                  <InputContainer
                    label="Amount"
                    name="amount"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedReconciliation.amount',

                      })
                    }}
                    type="number"
                    value={selectedReconciliation?.amount}
                  />                                
                  <InputContainer
                    label="Remarks"
                    name="Remarks"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedReconciliation.Remarks',

                      })
                    }}
                    type="text"
                    value={selectedReconciliation?.Remarks}
                  />      
          </div>
          <div className="flex justify-end mt-6">
            <button
              onClick={onClose}
              type="button"
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
            >
              Close
            </button>
            <button
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
              onClick={handleFormSubmit}
              type="submit"
            >
              Save
            </button>
          </div>
        </div>
      </div>

    </>
  )
}